import './image.less'
import React from 'react';
import * as PropTypes from 'prop-types';
import $ from 'jquery'
import classnames from 'classnames'
import tools from '../libs/tools';
//
import Component from '../core/component';
//import Enhance from '../core/enhance';
import debug from 'debug';

let log = debug('mobile.image')
//
let cache = {};

let TIMER = Symbol('timer')

function isElementInViewport(el) {
    //返回某个元素在视窗中的位置，包括left、right、top、bottom、width、height
    let rect1 = el.getBoundingClientRect();
    let rect2 = document.body.getBoundingClientRect();
    // log(rect1, rect2)
    return tools.collide(rect1, rect2)

    // return (
    //     (rect.top >= 0 && rect.top < window.innerHeight) && (rect.left >= 0 && rect.left < window.innerWidth)
    // );
}

class Image extends Component {

    state = {
        load: false,
        loading: true,
        imageSrc: '',
        base: '',
        src: '',
        innerStyle: {},
        style: {},
        timer: 0
    };

    static defaultProps = {
        scale: 1,
        timer: 0
    }

    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        $.extend(this.state, props);

        this.state.imageSrc = this.state.base + this.state.src;
        if (cache[this.state.imageSrc]) {
            this.state.load = true;
        }
    }


    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        $.extend(this.state, nextProps);
        if (nextProps.src == null) {
            this.setState({loading: true, imageSrc: null, innerStyle: {}}, () => {
                clearInterval(this.state.timer);
                this.state.timer = setInterval(this.handlerScroll, 500);
                this.handlerScroll();
            })
        } else if (this.props.src != nextProps.src) {
            this.state.imageSrc = this.state.base + this.state.src;
            if (cache[this.state.imageSrc]) {
                this.setImage();
            } else {
                this.forceUpdate(() => {
                    clearInterval(this.state.timer);
                    this.state.timer = setInterval(this.handlerScroll, 500);
                    this.handlerScroll();
                })
            }
        }
    }


    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        //debugger
        if (this.props.lazy === false) {
            this.handlerLoadImage()
        } else {
            setTimeout(() => {
                if (cache[this.state.imageSrc]) {
                    this.setImage()
                } else {
                    this.handlerScroll();
                    this.state.timer = setInterval(this.handlerScroll, 500);
                }
            }, this.props.timer || 0)

            this.state.size = [this.image.clientWidth, this.image.clientHeight];

            this.state.sizeTimer = setInterval(this[TIMER], 100)
        }
    }


    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        clearInterval(this.state.timer);
        clearInterval(this.state.sizeTimer);
    }

    /**
     *
     * @return {*}
     */
    render() {
        return (
            <div
                ref={image => this.image = image}
                className={classnames("c-image  c-image-bg", {'c-image-loading': this.state.loading},
                    {'animated fadeIn': !this.state.loading}, this.props.className)}
                style={$.extend({}, this.state.style, this.state.innerStyle)}
            >
            </div>
        );
    }

    /**
     * 图片加载完毕
     * @private
     */
    handlerLoad = (img) => {
        let {naturalWidth, naturalHeight} = img;

        cache[this.state.imageSrc] = {
            naturalWidth,
            naturalHeight
        };

        this.setImage()
    }

    /**
     *
     */
    setImage() {
        let {naturalWidth = 0, naturalHeight = 0} = cache[this.state.imageSrc] || {};

        let width = $(this.image).width() * this.props.scale;
        let height = $(this.image).height() * this.props.scale;

        let sw = 0, sh = 0;

        if (this.props.autoSize === false) {
            sw = width;
            sh = height;
        } else {
            // 图像比例
            let scaleW = width / naturalWidth;
            let scaleH = 0;

            // 以宽为基准值计算图片大小
            sw = naturalWidth * scaleW;
            sh = naturalHeight * scaleW;

            // 高超出范围的情况下
            if (sh > height) {
                // 计算高出比例
                scaleH = height / sh;
                sw = sw * scaleH;
                sh = sh * scaleH;
            }

            // 缩放率
            if (this.props.scale > 0) {
                sw = sw * this.props.scale;
                sh = sh * this.props.scale;
            }
        }

        this.setState({
            loading: false,
            show: true,
            innerStyle: {
                'backgroundPosition': 'center',
                'backgroundRepeat': 'no-repeat',
                'backgroundImage': 'url("' + this.state.imageSrc + '")',
                'backgroundSize': `${sw}px ${sh}px`
            }
        })
    }


    /**
     *
     * @private
     */
    handlerError = () => {
        cache[this.state.imageSrc] = false;
        this.state.timer = setInterval(this.handlerScroll, 500);
    }

    /**
     *
     * @private
     */
    handlerScroll = () => {
        if (!this.state.src)
            return;

        if (!this.image)
            return;

        if (isElementInViewport(this.image)) {

            clearInterval(this.state.timer);

            if (cache[this.state.imageSrc] != null) {
                this.setImage()
            } else {
                this.handlerLoadImage()
            }
        }
    }

    /**
     *
     */
    handlerLoadImage = () => {
        let img = new window.Image;
        img.onerror = this.handlerError;
        img.onload = () => {
            this.handlerLoad(img)
        };
        img.src = this.state.imageSrc;
        this.state.load = true;
    }

    /**
     *
     */
    [TIMER] = () => {
        let size = [this.image.clientWidth, this.image.clientHeight];
        if (this.state.size.toString() != size.toString()) {
            this.state.size = size;
            this.setImage()
            //log(size);
        }
    }
}


Image.displayName = 'Image';
Image.defaultProps = {}
Image.propTypes = {
    base: PropTypes.string,
    lazy: PropTypes.bool,
    src: PropTypes.string,
    size: PropTypes.number,
    timer: PropTypes.number
}

export default Image;
